import { RiFileList3Line, RiHome4Line, RiLeafLine, RiReceiptLine } from '@remixicon/react';

import SidebarLink from '../pageFrame/navigation/SidebarLink';

export default function CustomerPortalNavigation() {
  return (
    <>
      <SidebarLink text="Home" icon={RiHome4Line} href="/" />
      <SidebarLink text="Products" icon={RiLeafLine} href="/products" />
      <SidebarLink text="Purchase Orders" icon={RiFileList3Line} href="/purchase-orders" />
      <SidebarLink text="Invoices" icon={RiReceiptLine} href="/invoices" />
      {/* <SidebarLink text="Settings" icon={Settings} href="/settings" /> */}
    </>
  );
}
